import { apiClient } from './client';

export async function getTenantAccessStatus(tenantId) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/access-status`);
  return data;
}

export async function runTenantAccessCheck(tenantId, payload = {}) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/access-check`, payload);
  return data;
}

export async function getTenantAccessChecks(tenantId, params = {}) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/access-checks`, { params });
  return data;
}

export async function getTenantAccessEvents(tenantId, params = {}) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/access-events`, { params });
  return data;
}

export async function getTenantAccessOverrides(tenantId) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/access-overrides`);
  return data;
}

export async function createTenantAccessOverride(tenantId, payload) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/access-overrides`, payload);
  return data;
}

export async function revokeTenantAccessOverride(tenantId, overrideId, payload = {}) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/access-overrides/${overrideId}/revoke`, payload);
  return data;
}

export async function getTenantAccessSummary(params = {}) {
  const { data } = await apiClient.get('/api/system/tenant-access/summary', { params });
  return data;
}

export async function getTenantAccessAllChecks(params = {}) {
  const { data } = await apiClient.get('/api/system/tenant-access/checks', { params });
  return data;
}

export async function getTenantAccessAllEvents(params = {}) {
  const { data } = await apiClient.get('/api/system/tenant-access/events', { params });
  return data;
}

export async function getCustomerPortalTenantAccessStatus(customerId, tenantId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/tenants/${tenantId}/access-status`);
  return data;
}
